import React, {useEffect, useState} from 'react'
import {
    Container,
    ListItem,
    Text,
    TextTag,
    TokenTextAppearance,
    List,
    Breakpoints,
} from '@volkswagen-onehub/components-core'
import {SizeEnum} from '@volkswagen-onehub/tokens'
import {useTranslation} from 'react-i18next'

export function Editorial(): React.JSX.Element {
    const {t} = useTranslation('fa-flotte')
    const [texts, setTexts] = useState([])
    const [listItems, setListItems] = useState([])

    useEffect(() => {
        setTexts(t('dealer-form.texts', {returnObjects: true}))
        setListItems(t('dealer-form.list-items', {returnObjects: true}))
    }, [])

    return (
        <>
            <Text tag={TextTag.h2} appearance={TokenTextAppearance.headline300}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: t('dealer-form.editorial-title'),
                    }}
                />
            </Text>

            <Container
                padding={{
                    top: {
                        [Breakpoints.default]: SizeEnum.static500,
                    },
                    bottom: {
                        [Breakpoints.default]: SizeEnum.static565,
                    },
                    left: {
                        [Breakpoints.b960]: SizeEnum.grid001,
                    },
                    right: {
                        [Breakpoints.b960]: SizeEnum.grid001,
                    },
                }}
                gutter={SizeEnum.static500}
                wrap="always"
            >
                {texts.map(
                    (text: any, index) =>
                        text && (
                            <Container
                                wrap="always"
                                gutter={SizeEnum.static300}
                                key={index}
                            >
                                <Text
                                    tag={TextTag.h3}
                                    appearance={TokenTextAppearance.bigcopy100}
                                    bold
                                >
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: t(text.subtitle),
                                        }}
                                    />
                                </Text>

                                <Text
                                    tag={TextTag.p}
                                    appearance={TokenTextAppearance.copy200}
                                >
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: t(text.paragraph),
                                        }}
                                    />
                                </Text>
                            </Container>
                        )
                )}{' '}
            </Container>

            <Container
                padding={{
                    left: {
                        [Breakpoints.b960]: SizeEnum.grid001,
                    },
                    right: {
                        [Breakpoints.b960]: SizeEnum.grid001,
                    },
                }}
                wrap="always"
            >
                <Text
                    tag={TextTag.h3}
                    appearance={TokenTextAppearance.bigcopy100}
                    bold
                >
                    <span
                        dangerouslySetInnerHTML={{
                            __html: t('dealer-form.list-paragraph'),
                        }}
                    />
                </Text>

                <Container
                    padding={{
                        top: {
                            [Breakpoints.default]: SizeEnum.static200,
                        },
                    }}
                    wrap="always"
                >
                    <List isOrdered>
                        {listItems.map(
                            (item, index) =>
                                item && <ListItem key={index}>{item}</ListItem>
                        )}
                    </List>
                </Container>
            </Container>
        </>
    )
}
